<template>
  <svg
    id="Plus"
    xmlns="http://www.w3.org/2000/svg"
    width="13.371"
    height="13.371"
    viewBox="0 0 13.371 13.371"
  >
    <rect
      id="Rechteck_973"
      data-name="Rechteck 973"
      width="1.254"
      height="13.371"
      rx="0.5"
      transform="translate(6.059)"
      :class="fillClass + ' transition-fill'"
    />
    <rect
      id="Rechteck_974"
      data-name="Rechteck 974"
      width="1.254"
      height="13.371"
      rx="0.5"
      transform="translate(13.371 6.059) rotate(90)"
      :class="fillClass + ' transition-fill'"
    />
  </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlusIcon",
  props: {
    fillClass: {
      type: String,
      default: "",
    },
  },
});
</script>
